var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.00619C22 7.82263 21.9244 7.64732 21.7986 7.51532L14.993 0.641006C14.7242 0.369443 14.289 0.370131 14.0209 0.641006C13.7521 0.911881 13.7521 1.35188 14.0209 1.62276L19.6536 7.31182H0.6875C0.308 7.31182 0 7.62257 0 8.00619C0 8.38982 0.308 8.70057 0.6875 8.70057H19.6529L14.0209 14.3896C13.7521 14.6605 13.7527 15.1005 14.0209 15.3714C14.2897 15.6423 14.7249 15.6423 14.993 15.3714L21.7986 8.49707C21.9271 8.36713 21.9979 8.18838 22 8.00619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowMark);
export default __webpack_public_path__ + "static/media/right-arrow-mark.ad3e4d2db47569cf40951e6297cfd229.svg";
export { ForwardRef as ReactComponent };